import React, { useState, useEffect } from 'react'
import { Input } from '@/components/ui/input'
export function DebouncedInput({ value: initialValue, onChange, debounce = 500, ...props }) {
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value)
        }, debounce)
        return () => clearTimeout(timeout)
    }, [value, debounce, onChange])

    return (
        <Input
            {...props}
            value={value}
            onChange={e => setValue(e.target.value)}
        />
    )
}
